import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {apiRequest, ajaxWatched } from "../../shared/services";

function authenticateUser(username, password){
    let resource = '/auth/login';

    return (dispatch, getState, handleResponse) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, resource, {
                method: 'POST',
                body: JSON.stringify({
                    username: username,
                    password: password
                })
            })
        ))
    }
}

const LogIn = props => {
    //props.location.state.from
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);

    if (props.user.authToken){
        return <Redirect to={props.location.state.from} />
    }

    function logIn(event) {
        event.preventDefault();
        props.dispatch(authenticateUser(username, password, ));
    }

    return (
        <div className="ac-manager">
            <form onSubmit={logIn}>
                <h2>Log In</h2>
                <label htmlFor="username">Username:</label>
                <input type="text" id="username" name="username" defaultValue={username} onChange={e => setUsername(e.target.value)} />

                <label htmlFor="password">Password:</label>
                <input type="password" id="password" name="password" defaultValue={password} onChange={e => setPassword(e.target.value)} />

                <input type="submit" value="Log In" />
            </form>
        </div>
    );
};

function mapStateToProps(state) {
    return { user: state.user };
}

export default connect(mapStateToProps)(LogIn);